import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../lib/firebase';

export async function fetchSponsorshipBadge(userCompanyId: string) {
  if (!userCompanyId || userCompanyId.trim() === '') {
    return { companyName: '', sponsorshipBadge: null as null | { enabled: boolean; text: string; logoUrl: string } };
  }

  try {
    const companyRef = doc(db, 'companies', userCompanyId);
    const companyDoc = await getDoc(companyRef);
    
    if (!companyDoc.exists()) {
      if (process.env.NODE_ENV !== 'production') {
        console.warn(`Company document not found for ID: ${userCompanyId}`);
      }
      return { companyName: '', sponsorshipBadge: null as null | { enabled: boolean; text: string; logoUrl: string } };
    }
    
    const companyData = companyDoc.data() as any;
    
    // Check if company has a name field
    if (!companyData || !companyData.name || companyData.name.trim() === '') {
      if (process.env.NODE_ENV !== 'production') {
        console.warn(`Company document exists but has no name field for ID: ${userCompanyId}`);
      }
      return { companyName: '', sponsorshipBadge: null as null | { enabled: boolean; text: string; logoUrl: string } };
    }
    
    const sponsorshipSettings = companyData?.settings?.sponsorshipBadge;
    return {
      companyName: companyData.name.trim(),
      sponsorshipBadge: sponsorshipSettings ? {
        enabled: sponsorshipSettings.enabled || false,
        text: sponsorshipSettings.text || '',
        logoUrl: sponsorshipSettings.logoUrl || ''
      } : null,
    };
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') {
      console.error('Error fetching sponsorship badge:', error);
    }
    return { companyName: '', sponsorshipBadge: null as null | { enabled: boolean; text: string; logoUrl: string } };
  }
}


